<template>
    <div>
        <div v-show="pageType == 1">
            <el-form :inline="true" class="query-form" size="mini" ref="form">
                <el-form-item class="query-form-item">
                    <el-form-item label="" class="query-form-item">
                        <el-button type="primary" icon="el-icon-back" @click="goBackListBtn()"></el-button>
                    </el-form-item>

                    <el-form-item label="任务名称：" class="query-form-item">
                        <el-input v-model="query.content" placeholder="请输入任务名称"></el-input>
                    </el-form-item>
                    <el-form-item label="工作节点：" class="query-form-item">
                        <el-input v-model="query.tfsName" placeholder="请输入状态节点"></el-input>
                    </el-form-item>
                    <el-form-item label="" class="query-form-item" v-show="pageData.sub_index < 2">
                        <el-checkbox v-model="query.only_show_parent_task">仅显示父任务</el-checkbox>
                    </el-form-item>
                    <el-form-item label="是否完成：" class="query-form-item">
                        <el-select v-model="query.isDone" placeholder="是否完成" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" icon="search" @click="onQuery">查询</el-button>
                    </el-form-item>
                </el-form-item>
            </el-form>

            <el-table v-loading="loading" :data="list" size="mini" ref="multipleTable"
                      @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                      @selection-change="handleSelectionChange" :height="tableHeight"
                      border @sort-change="handleSortChange" :row-key="getRowKeys">
                <el-table-column label="任务id" width="130" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.id }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="项目id" width="130" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.projectId }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="项目名" width="200" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.project_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="父任务id" width="130" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.parentTaskId }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="任务名称" width="220" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.content }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="备注" width="130" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.note }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="是否完成" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.isDone == 1 ? '是' : '否' }}</div>
                    </template>
                </el-table-column>


                <el-table-column label="开始日期" width="140" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.startDate }}</div>
                    </template>
                </el-table-column>


                <el-table-column label="截止日期" width="140" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.dueDate }}</div>
                    </template>
                </el-table-column>


                <el-table-column label="完成日期" width="140" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.accomplishTime }}</div>
                    </template>
                </el-table-column>


                <el-table-column label="工作节点" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.tfsName }}</div>
                    </template>
                </el-table-column>


                <el-table-column label="创建时间" width="140" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.created }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="更新时间" width="140" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.updated }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="创建人" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.creatorUser }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="执行人" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.executorUser }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="参与人" width="120" align="center">
                    <template slot-scope="scope">
                        <div>{{ ( scope.row.involveUser || [] ).toString()}}</div>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="170" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button style="margin: 5px 0 5px 10px" type="primary" size="mini" v-show="pageData.sub_index < 4"
                                   @click="seeSubTask(scope.row)">
                            查看子任务
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :current-page="query.page"
                :page-sizes="[10, 50, 100]"
                :total="query.total"
                background
                style="display: flex;justify-content: end;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </div>
        <div v-if="pageType == 2">
            <enterProject :childData="toChildData" @goBackList="goBackList"></enterProject>
        </div>
    </div>

</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import enterProject from './enterProject'

    export default {
        name: 'enterProject',
        components: {enterProject},
        props: ['childData'],
        watch: {
            childData: {
                handler(data) {
                    console.log('childData', data)
                    if (data) {
                        this.openPage(data)
                    }
                },
                deep: true,
                immediate: true
            }
        },
        data() {
            return {
                pageType: 1,
                pageData: {},
                toChildData: {},
                multipleSelection: [],
                tableHeight: null,
                managerAnalysisList: [],
                developerList: [],
                list: [],
                loading: false,
                query: {
                    content: '',
                    tfsName: '',
                    isDone: '',
                    only_show_parent_task: true,
                    page: 1,
                    limit: 10,
                    total: 0,
                },
                ctrl: {
                    DownloadListDialogVisible: false,
                    uploadDialogVisible: false,
                    bidDialogVisible: false,
                    childInfoVisible: false,
                },
            }
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        methods: {
            goBackListBtn(){
                this.query = {
                    page: 1,
                    limit: 10,
                    total: 0,
                }
                this.list = []
                this.pageType = 1
                this.$emit('goBackList')
            },
            seeSubTask(data) {
                this.pageType = 2
                data.sub_index = this.pageData.sub_index + 1
                data.projectId = this.query.projectId
                this.toChildData = data
            },
            goBackList() {
                this.pageType = 1
                console.log('--goBack', this.pageData.sub_index, this.pageData)
                // this.getList()
                console.log('this.query', this.query)
            },
            onQuery() {
                this.query.page = 1
                this.getList()
            },
            openPage(data) {
                this.pageData = data
                this.query.only_show_parent_task = data.sub_index > 1 ? false : true
                if(data.sub_index == 1) {
                    this.query.projectId = data.id
                } else {
                    this.query.parentTaskId = data.id
                    this.query.projectId =  data.projectId
                }
                this.getList()
            },
            operatorAsinList(row) {
                this.$refs.operatorListModal.showModal(row.id)
            },
            getRowKeys(row) {
                return row.id
            },

            jumpUrl(url) {
                window.open(url, '_blank')
            },
            //重置
            onReset() {
                this.query = {
                    title: '',
                    status: '',
                    purchase_status: '',
                    operation_id: '',
                    developer_id: '',
                    category_state: '',
                    asin: '',
                    deliver_mode: '',
                    min_freight_difference: undefined,
                    max_freight_difference: undefined,
                    min_weight: undefined,
                    max_weight: undefined,
                    min_early_profit: undefined,
                    max_early_profit: undefined,
                    page: 1,
                    limit: 10,
                    total: 0,
                }
                this.getList()
            },
            detailFunc(data) {
                this.$refs.detailPreview.visible = true
                this.$refs.detailPreview.title = '详情展示'
                this.$refs.detailPreview.formData = data
                this.$refs.detailPreview.funcType = 1
            },
            cardFunc(data) {
                this.$refs.card.showModal(data)
            },
            exportFunc(data) {
                api.operation_index_export({id: data.id}).then((res) => {
                    if (res.success) {
                        this.downFile(res.data)
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            closeCllback(isShow) {
                this.showAddRecord = false
                this.showAddParseModal = false
                this.ctrl.childInfoVisible = false
                this.updateData = {}
                isShow == true && this.getList()
            },
            /**
             * 数字相乘
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accMul(arg1, arg2) {
                let m = 0
                m = this.accAdd(m, this.getDecimalLength(arg1))
                m = this.accAdd(m, this.getDecimalLength(arg2))
                return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
            },
            getNum(arg = '') {
                return Number((arg || "").toString().replace('.', ''))
            },
            /**
             * 数字相加
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accAdd(arg1, arg2) {
                return this.changeNum(arg1, arg2)
            },
            changeNum(arg1 = '', arg2 = '', isAdd = true) {
                const changeInteger = (arg, r, maxR) => {
                    if (r != maxR) {
                        let addZero = ''
                        for (let i = 0; i < maxR - r; i++) {
                            addZero += '0'
                        }
                        arg = Number(arg.toString().replace('.', '') + addZero)
                    } else {
                        arg = this.getNum(arg)
                    }
                    return arg
                }

                let r1, r2, maxR, m
                r1 = this.getDecimalLength(arg1)
                r2 = this.getDecimalLength(arg2)
                maxR = Math.max(r1, r2)
                arg1 = changeInteger(arg1, r1, maxR)
                arg2 = changeInteger(arg2, r2, maxR)
                m = Math.pow(10, maxR)
                if (isAdd) {
                    return (arg1 + arg2) / m
                } else {
                    return (arg1 - arg2) / m
                }
            },
            getDecimalLength(arg = '') {
                try {
                    return arg.toString().split('.')[1].length
                } catch (e) {
                    return 0
                }
            },

            spanMethod({row, column, rowIndex, columnIndex}) {

                const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
                if (rowIndex % 3 == 0) {
                    if (columns.includes(columnIndex)) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                    return {
                        rowspan: 3,
                        colspan: 1
                    }
                } else {
                    if (columns.includes(columnIndex)) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            },
            //查询
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            // 数据迁移
            dataMigration() {
                if (this.multipleSelection.length > 0) {
                    this.$refs.dataMigrationModal.showModal(this.subLibraryDetailInfo.id, this.multipleSelection)
                } else {
                    this.$message.info('请勾选需要迁移的数据')
                }
            },
            clickRowHandle(row, column) {
                if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                    this.childInfo.title = column.label
                    let info = row.title
                    if (column.label == '类目树') {
                        info = row.category_tree
                    } else if (column.label == '子类目') {
                        info = row.categories_str
                    } else if (column.label == '颜色') {
                        info = row.color
                    } else if (column.label == '1688产品标题') {
                        info = row.ali_title
                    }
                    this.childInfo.info = info
                    this.ctrl.childInfoVisible = true
                }
                if (['折叠', '收起'].includes(column.label)) {
                    this.isFold = !this.isFold
                }
            },
            clickHeaderHandle(row, column) {
                if (['折叠', '收起'].includes(row.label)) {
                    this.isFold = !this.isFold
                }
            },
            handleSortChange(val) {
                if (val.order == 'ascending') {
                    this.query.desc = 'desc'
                    this.query.order = val.prop
                } else if (val.order == 'descending') {
                    this.query.desc = 'asc'
                    this.query.order = val.prop
                }
                this.getList()
            },
            handleSelectionChange(val) {
                let arr = []
                val.map(v => {
                    arr.push(v.id)
                })
                arr = Array.from(new Set(arr))
                this.multipleSelection = arr
            },
            chooseItem(data) {
                this.$emit('choose1688Info', data)
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                let tempQuery = JSON.parse(JSON.stringify(this.query))
                tempQuery.only_show_parent_task = tempQuery.only_show_parent_task ? 1 : 0
                api.admin_teambition_project_task_lists(tempQuery).then(res => {
                    if (res.code === 0) {
                        const responseList = res.data.list || []
                        console.log('responseList',responseList)
                        this.list = responseList
                        this.query.total = res.data.total || 0
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                }).finally(() => {
                    this.loading = false
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.loading = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .canClick {
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }

    .fixedHeight {
        height: 30px;
        line-height: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>


